<mat-card class="cardStyle">
    <div class="spaceDiv">
        <div class="divTitle">
            <div class="row cardContent">
                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 d-flex align-items-center">
                    <span class="textCard">{{superGroup.description}}</span>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 radioButtonStyle">
                    <mat-radio-group [(ngModel)]="selected">
                        <mat-radio-button 
                         [id]="superGroup.description"
                         [value]="true" 
                         class="radioButton"
                         (click)="clickSuperGroup()"
                         ></mat-radio-button>
                    </mat-radio-group>
                    
                </div>
            </div>
        </div>
        <div class="divDivider">
            <mat-divider></mat-divider>
        </div>
        <div class="divChecks">
            <mat-chip-listbox #chipList multiple="true">
                <mat-chip *ngFor="let obj of superGroup.thematics"
                    [id]="obj.code"
                    [class]="obj.code"
                    [ngClass]="{'activeSelect' : obj.selected === true, 'inactiveSelect' : obj.selected === false}"
                    (click)="clickThematic(obj)">
                    <span style="white-space: break-spaces;">{{obj.description}}</span>
                </mat-chip>
            </mat-chip-listbox>
        </div>
    </div>

</mat-card>